export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 3-1_03.85cdc0b7.jpg";